import React from 'react';
import { Link } from 'react-router-dom';
import { startingDataColumns, startingDataRows } from '../data/startingData';
interface StartingDataTableProps {
  linkMaterials?: boolean;
}

/** Published starting guidance: semantic table at md+, labeled stacked
 *  records below md. Shared by the homepage and the Starting Data page. */
export function StartingDataTable({
  linkMaterials = false
}: StartingDataTableProps) {
  function materialCell(material: string, href: string, tone: 'dark' | 'light') {
    if (!linkMaterials) return material;
    return <Link to={href} className={`underline decoration-copper underline-offset-4 hover:text-copper ${tone === 'light' ? 'text-white' : 'text-navy'}`} data-id="element-624" data-mp="2hl5h7qlws2wu">
        {material}
      </Link>;
  }
  return <div data-id="element-625" data-mp="358wuoxj6qlzp">
      <div className="hidden border border-rule bg-white md:block" data-id="element-626" data-mp="359opw78vehpg">
        <table className="w-full border-collapse text-left" data-id="element-627" data-mp="30i6q3mil2n62">
          <caption className="sr-only" data-id="element-628" data-mp="30gn9fut0ma3r">
            Published Shear Geometry starting guidance by material. Speed in
            surface feet per minute, depth of cut per side in inches, feed in
            inches per revolution.
          </caption>
          <thead data-id="element-629" data-mp="1bnpwwk474fs7">
            <tr className="bg-navy" data-id="element-630" data-mp="1bm53ixtmb2vx">
              {startingDataColumns.map(col => <th key={col} scope="col" className="border-r border-white/10 px-4 py-3.5 font-mono text-[10px] font-medium tracking-label text-aluminum last:border-r-0" data-id="element-631" data-mp="1glhplgco05xg">
                  {col.toUpperCase()}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-632" data-mp="sqeuiqn9p68j">
            {startingDataRows.map(row => <tr key={row.material} className="border-t border-rule align-top" data-id="element-633" data-mp="xo6orrbdx4fw">
                <th scope="row" className="border-r border-rule px-4 py-4 text-[14px] font-semibold text-navy" data-id="element-634" data-mp="2n23c70kvvmwm">
                  {materialCell(row.material, row.href, 'dark')}
                </th>
                <td className="border-r border-rule px-4 py-4 font-mono text-[12.5px] leading-relaxed text-graphite" data-id="element-635" data-mp="2qhwipfqq8p0j">
                  {row.insert}
                </td>
                <td className="rp-tabular border-r border-rule px-4 py-4 font-mono text-[12.5px] leading-relaxed text-graphite" data-id="element-636" data-mp="2gmldpp54ew5z">
                  {row.speed}
                </td>
                <td className="rp-tabular border-r border-rule px-4 py-4 font-mono text-[12.5px] leading-relaxed text-graphite" data-id="element-637" data-mp="399paj6u2846o">
                  {row.doc}
                </td>
                <td className="rp-tabular border-r border-rule px-4 py-4 font-mono text-[12.5px] leading-relaxed text-graphite" data-id="element-638" data-mp="2zkfits34onj3">
                  {row.feed}
                </td>
                <td className="px-4 py-4 text-[13px] leading-relaxed text-graphite/85" data-id="element-639" data-mp="3s18crbg9fe7n">
                  {row.source}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="space-y-5 md:hidden" data-id="element-640" data-mp="19s5ioigzjiam">
        {startingDataRows.map(row => <article key={row.material} aria-label={row.material} className="border border-rule bg-white" data-id="element-641" data-mp="1eqyrvyp8on4z">
            <h3 className="border-b border-rule bg-navy px-4 py-3 text-[14px] font-semibold text-white" data-id="element-642" data-mp="1ir0mxp0gyiba">
              {materialCell(row.material, row.href, 'light')}
            </h3>
            <dl className="divide-y divide-rule" data-id="element-643" data-mp="1spoutuyqph19">
              {[['Insert', row.insert], ['Speed', row.speed], ['DOC per side', row.doc], ['Feed', row.feed], ['Source condition / notes', row.source]].map(([label, value]) => <div key={label} className="px-4 py-3" data-id="element-644" data-mp="26hd1vju4tfbd">
                  <dt className="font-mono text-[9.5px] tracking-label text-copper" data-id="element-645" data-mp="2bi0si4eg7u52">
                    {String(label).toUpperCase()}
                  </dt>
                  <dd className="rp-tabular mt-1.5 font-mono text-[13px] leading-relaxed text-graphite" data-id="element-646" data-mp="2gdzly6emw2cc">
                    {value}
                  </dd>
                </div>)}
            </dl>
          </article>)}
      </div>
    </div>;
}